export default [
    {
        path: '/magazine',
        props: true,
        component: () => import('@/views/Magazine'),
    },
    {
        path: '/magazine/export',
        props: true,
        component: () => import('@/views/Magazine/Export'),
        meta: {
            activates: '/magazine',
        }
    },
];
